module.exports = __webpack_public_path__ + "img/M-icon.d379c957.png";